module.exports = __webpack_public_path__ + "img/NO937903979.f72282a4.png";